// extracted by mini-css-extract-plugin
export var aniSpin = "l_d";
export var button = "l_n";
export var button__inner = "l_p";
export var button__text = "l_q";
export var container = "l_m";